import { HorizontalBar, mixins } from "vue-chartjs";
import isEqual from "lodash.isequal";
import color from "../../assets/utils/color";
const { reactiveProp } = mixins;
export default {
  extends: HorizontalBar,
  mixins: [reactiveProp],
  props: {
    options: {
      type: Object,
      default() {
        return {};
      }
    },
    chartData: {
      type: Object,
      required: false
    },
    headline: {
      type: String,
      default: () => "Quellen"
    }
  },
  mounted() {
    this.updateChart();
  },
  watch: {
    chartData(value, oldValue) {
      if (value && (!oldValue || !isEqual(value, oldValue))) {
        this.updateChart(value);
      }
    }
  },
  data() {
    return {
      legendItems: {}
    };
  },
  methods: {
    updateChart(value) {
      if (!value) {
        return;
      }
      this.renderChart(
        value,
        Object.assign(
          {
            title: {
              display: true,
              text: this.headline
            },
            responsive: true,
            maintainAspectRatio: false,
            interaction: {
              intersect: false
            },
            legend: {
              labels: {
                generateLabels(chart) {
                  return chart.scales["y-axis-0"].ticks
                    .map(label => {
                      return {
                        text: label,
                        fillStyle: colorFromLabel(label),
                        lineCap: "butt",
                        lineDashOffset: 0.0,
                        lineDash: [],
                        lineJoin: "miter",
                        lineWidth: 0.0,
                        strokeStyle: colorFromLabel(label),
                        hidden: false
                      };
                    })
                    .filter(x => x);
                }
              },
              onClick: function(e, legendItem) {
                let datasets = this.chart.data.datasets;
                for (let i = 0; i < datasets.length; i++) {
                  if (legendItem.fillStyle == datasets[i].backgroundColor) {
                    let meta = this.chart.getDatasetMeta(i);
                    meta.hidden =
                      meta.hidden === null
                        ? !this.chart.data.datasets[i].hidden
                        : null;
                  }
                }
                legendItem.hidden = !legendItem.hidden;
                this.chart.update();
              }
            },
            tooltips: {
              filter(item, data) {
                let dataset = data.datasets[item.datasetIndex];
                return (
                  item.value != "0" &&
                  dataset.data.map(x => String(x)).find(x => x == item.value)
                );
              },
              callbacks: {
                label(tooltipItem, object) {
                  let transform = object.datasets[0].transform;
                  return transform(tooltipItem.value);
                }
              }
            },
            scales: {
              xAxes: [
                {
                  stacked: true,
                  ticks: { beginAtZero: true }
                }
              ],
              yAxes: [
                {
                  stacked: true
                }
              ]
            }
          },
          this.options
        )
      );
    }
  }
};
function colorFromLabel(label) {
  const colors = {
    Cleverreach: "#ec6702",
    Facebook: "#4267B2",
    Google: "#DB4437"
  };
  if (colors[label]) {
    return colors[label];
  }
  return color.colorFromString(label);
}
